export function generateTraceParent(win: Window | undefined): string {
  const version = '00'; //hardcoded version number
  const traceId = getHexValue(win, 16);
  const parentId = getHexValue(win, 8);
  const flags = '01';

  return `${version}-${traceId}-${parentId}-${flags}`;
}

function getHexValue(win: Window | undefined, bytes: number): string {
  if (win?.crypto?.getRandomValues) {
    try {
      const array = new Uint8Array(bytes);
      win.crypto.getRandomValues(array);
      return Array.from(array)
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    } catch {
      console.warn('Crypto.getRandomValues failed. Falling back to math.random()');
    }
  }

  return cryptoRandomValuesFallback(bytes);
}

function cryptoRandomValuesFallback(bytes: number) {
  return Array.from({ length: bytes }, () =>
    Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0'),
  ).join('');
}
